var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-holder"},[_c('NoUISlider',{attrs:{"values":_vm.topindex,"config":_vm.config,"id":"indexSlider"},on:{"update:values":function($event){_vm.topindex=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }